import { createSelector } from 'reselect';
import get from 'lodash/get';
import { stateSelector } from '@store/router/selectors';
import moment from 'moment-timezone';
import { ALL_TRAFFIC } from '@utils/filter';
import baseSelector, {
  intervalSelector,
} from '@store/errorDiagnostics/base/selectors';
import birdChartSelector from '@store/errorDiagnostics/birdChart/selectors';
import dimensionTablesSelector from '@store/errorDiagnostics/dimensionTables/selectors';
import viewerSessionsSelector from '@store/viewerSessions/selectors';
import scrollingWindowFromTo from '@utils/scrollingWindowFromTo';

import { getColor } from '@utils';
import { SCOPE } from './types';

const selector = state => state[SCOPE];

export default selector;

export const filterFromRouterSelector = createSelector(
  stateSelector,
  routerStateStore => ({
    rule: get(routerStateStore, 'filter.rule', ALL_TRAFFIC.rule),
    name: get(routerStateStore, 'filter.name', ALL_TRAFFIC.name),
  }),
);

export const filterColorSelector = createSelector(
  filterFromRouterSelector,
  filter => getColor(0, filter.name),
);

export const tempDashboardSelector = createSelector(
  baseSelector,
  intervalSelector,
  dimensionTablesSelector,
  birdChartSelector,
  viewerSessionsSelector,
  (
    baseStore,
    interval,
    dimensionTablesStore,
    birdChartStore,
    viewerSessionsStore,
  ) => {
    const {
      sliceFrom,
      sliceTo,
      zoomStart,
      zoomEnd,
      brushStart,
      brushEnd,
    } = birdChartStore;

    const selectedMetrics = get(
      viewerSessionsStore,
      [baseStore.currentErrorCode, 'selectedMetrics'],
      [],
    );

    return scrollingWindowFromTo({
      viewerSessionsTable: {
        selectedMetrics,
      },
      base: {
        ...baseStore,
        interval: {
          ...baseStore.interval,
          ...interval,
        },
      },
      dimensionTables: dimensionTablesStore.core,
      birdChart: {
        sliceFrom: sliceFrom ? moment(sliceFrom).toISOString() : sliceFrom,
        sliceTo: sliceTo ? moment(sliceTo).toISOString() : sliceTo,
        zoomStart,
        zoomEnd,
        brushStart,
        brushEnd,
      },
    });
  },
);

export const dashboardSelector = createSelector(
  tempDashboardSelector,
  store => ({ ...store }),
);
